const STORAGE_KEY = 'storefront-otp-token';

function findToken(input, depth = 0) {
  if (!input || depth > 5) return '';
  if (typeof input === 'string') return depth === 0 ? input.trim() : '';
  if (typeof input !== 'object') return '';

  const direct =
    input.token ||
    input.Token ||
    input.otp_token ||
    input.otpToken ||
    input.OtpToken ||
    input.verification_token ||
    input.verificationToken ||
    input.VerificationToken ||
    input.reset_token ||
    input.resetToken ||
    input.ResetToken ||
    '';

  if (direct) return String(direct).trim();

  for (const [key, value] of Object.entries(input)) {
    if (
      (typeof value === 'string' || typeof value === 'number') &&
      key.toLowerCase().includes('token') &&
      String(value).trim()
    ) {
      return String(value).trim();
    }

    const nested = findToken(value, depth + 1);
    if (nested) return nested;
  }

  return '';
}

function storageKey(email, purpose) {
  return `${STORAGE_KEY}:${purpose || 'otp'}:${String(email || '').toLowerCase()}`;
}

export function extractOtpToken(resp) {
  return findToken(resp);
}

export function saveOtpToken({ email, purpose, token }) {
  if (!token) return;
  try {
    window.sessionStorage.setItem(storageKey(email, purpose), token);
  } catch {
    // Session storage can be unavailable in private/restricted contexts.
  }
}

export function readOtpToken({ email, purpose }) {
  try {
    return window.sessionStorage.getItem(storageKey(email, purpose)) || '';
  } catch {
    return '';
  }
}

export function clearOtpToken({ email, purpose }) {
  try {
    window.sessionStorage.removeItem(storageKey(email, purpose));
  } catch {
    // Ignore storage cleanup failures.
  }
}
